import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import LinkIcon from '@material-ui/icons/Link';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import CloudDownload from '@material-ui/icons/CloudDownload';
import WarningIcon from '@material-ui/icons/Warning';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PaymentIcon from '@material-ui/icons/Payment';
import BlockIcon from '@material-ui/icons/Block';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'moment/locale/pt-br';
import moment from 'moment';
import { instanceAxios } from '../../InstanceAxios';
import { formatMoney } from '../../utils/common';
import Reembolso from './components/ReembolsoModal';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function Cupons() {
  const classes = useStyles();
  const columns = [
    { id: 'usuario', label: 'Usúario', minWidth: 140 },
    { id: 'metodo_pagamento', label: 'Forma de Pagamento', minWidth: 140 },
    { id: 'valor', label: 'Valor', minWidth: 80 },
    { id: 'data', label: 'Data', minWidth: 140 },
    { id: 'fatura_pdf', label: 'PDF Fatura', minWidth: 70 },
    { id: 'reembolsar', label: 'Reembolso', minWidth: 70 },
    { id: 'nota', label: 'Nota', minWidth: 70 },
    { id: 'emitir', label: 'Emitir Nota', minWidth: 70 },
  ];

  const [ready, setReady] = useState(false);
  const [pagamentos, setPagamentos] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [tipo, setTipo] = useState('ASSINATURAS');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [mes, setMes] = useState(moment().subtract(1, 'month').format('MM'));
  const [ano, setAno] = useState(
    mes === '12' ? moment().subtract(1, 'year').year() : moment().year()
  );
  const [meses, setMeses] = useState([
    { nome: 'JAN', valor: '01' },
    { nome: 'FEV', valor: '02' },
    { nome: 'MAR', valor: '03' },
    { nome: 'ABR', valor: '04' },
    { nome: 'MAI', valor: '05' },
    { nome: 'JUN', valor: '06' },
    { nome: 'JUL', valor: '07' },
    { nome: 'AGO', valor: '08' },
    { nome: 'SET', valor: '09' },
    { nome: 'OUT', valor: '10' },
    { nome: 'NOV', valor: '11' },
    { nome: 'DEZ', valor: '12' },
  ]);
  const [anos, setAnos] = useState([
    { nome: '2019', valor: '2019' },
    { nome: '2020', valor: '2020' },
    { nome: '2021', valor: '2021' },
    { nome: '2022', valor: '2022' },
  ]);
  const [idPagamento, setIdPagamento] = useState('');
  const [openReembolso, setOpenReembolso] = useState(false);

  useEffect(() => {
    if (!openReembolso) {
      fetchPagamentos(mes, ano, page, limit, tipo);
    }
  }, [ano, limit, mes, openReembolso, page, tipo]);

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const fetchPagamentos = async (m, a, p, l, t) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/pagamentos?mes=${m}&ano=${a}&limit=${l}&page=${p}&tipo=${t}`)
      .then((res) => {
        setPagamentos(res.data.rows);
        setCount(res.data.count);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setPagamentos([]);
        setCount(0);
        setMessage('Erro ao atualizar Pagamentos,tente novamente mais tarde!');
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
  };

  const handleChangeMes = (event) => {
    setMes(event.target.value);
    setPage(0);
    setLimit(5);
  };

  const handleChangeAno = (event) => {
    setAno(event.target.value);
    setPage(0);
    setLimit(5);
  };

  const handleTipo = (t) => {
    if (t !== tipo) {
      setPagamentos([]);
      setTipo(t);
    }
  };

  const handleErrorNota = (p) => {
    console.log(p);
    let msg;
    if (!p) {
      msg = 'Erro Interno';
    } else if (p.valor === 0) {
      msg = 'Não é possível emitir Nota para valor R$0.00';
    } else if (!p.NfeXmei) {
      msg = 'Fora do Periodo de emisão.Emissão realizada no final do mês!';
    } else if (p.NfeXmei.nfe_status === 'success') {
      msg = 'Aguardando Homologação!';
    } else if (p.NfeXmei.nfe_motivo_status) {
      msg = p.NfeXmei.nfe_motivo_status;
    } else {
      p = 'Erro Ao Emitir Nota';
    }

    setMessage(msg);
    setAlertType('warning');
    setAlert(true);
  };

  const handleEmitirNota = async (id, t) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/emitirNotaXmei?tipo=${t}&id=${id}`)
      .then((res) => {
        const pas = pagamentos.map((pa) => {
          if (pa.id === id) {
            pa.NfeXmei = res.data.data;
            return pa;
          }
          return pa;
        });
        setPagamentos(pas);
        setMessage(res.data.message);
        setAlertType(res.data.status);
        setAlert(true);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage(err.data.message);
        setAlertType('warning');
        setAlert(true);
        setReady(true);
      });
  };

  const handleReembolso = (id) => {
    setIdPagamento(id);
    setOpenReembolso(true);
  };

  const rowsAssinaturas = () => {
    return (
      <>
        {pagamentos.map((pa) => {
          return (
            <TableRow key={pa.id}>
              <TableCell component="th" scope="row" align="center">
                {pa.User ? pa.User.nome : ''}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {['credit card', 'credit_card'].includes(pa.metodo_pagamento)
                  ? 'Cartão de Crédito'
                  : 'Boleto Bancário'}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {formatMoney(pa.valor / 100)}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {moment(pa.createdAt).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                <Link href={pa.url_fatura_pdf} target="_blank">
                  <LinkIcon />
                </Link>
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                <IconButton onClick={() => handleReembolso(pa.id_fatura)}>
                  <PaymentIcon style={{ color: 'red' }} />
                </IconButton>
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {pa.NfeXmei && pa.NfeXmei.url_pdf_enotas ? (
                  <Link href={pa.NfeXmei.url_pdf_enotas} target="_blank">
                    <CloudDownload />
                  </Link>
                ) : (
                  <IconButton onClick={() => handleErrorNota(pa)}>
                    <WarningIcon />
                  </IconButton>
                )}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {pa.NfeXmei &&
                (pa.NfeXmei.nfe_status === 'error' ||
                  pa.NfeXmei.nfe_status === 'Negada') &&
                pa.valor !== 0 ? (
                  <IconButton
                    onClick={() => handleEmitirNota(pa.id, 'ASSINATURA')}
                  >
                    <AddCircleIcon />
                  </IconButton>
                ) : (
                  <BlockIcon />
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };
  const rowsServicos = () => {
    return (
      <>
        {pagamentos.map((ps) => {
          return (
            <TableRow key={ps.id}>
              <TableCell component="th" scope="row" align="center">
                {ps.ServicoContratado.Usuario
                  ? ps.ServicoContratado.Usuario.nome
                  : ''}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {ps.metodo_pagamento === 'credit_card'
                  ? 'Cartão de Crédito'
                  : 'Boleto Bancário'}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {formatMoney(ps.valor / 100)}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {moment(ps.createdAt).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                <Link href={ps.url_fatura_pdf} target="_blank">
                  <LinkIcon />
                </Link>
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                <IconButton onClick={() => handleReembolso(ps.id_fatura)}>
                  <PaymentIcon style={{ color: 'red' }} />
                </IconButton>
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {ps.NfeXmei && ps.NfeXmei.url_pdf_enotas ? (
                  <Link href={ps.NfeXmei.url_pdf_enotas} target="_blank">
                    <CloudDownload />
                  </Link>
                ) : (
                  <IconButton onClick={() => handleErrorNota(ps)}>
                    <WarningIcon />
                  </IconButton>
                )}
              </TableCell>
              <TableCell component="th" scope="row" align="center">
                {ps.NfeXmei &&
                (ps.NfeXmei.nfe_status === 'error' ||
                  ps.NfeXmei.nfe_status === 'Negada') &&
                ps.valor !== 0 ? (
                  <IconButton
                    onClick={() => handleEmitirNota(ps.id, 'SERVICO')}
                  >
                    <AddCircleIcon />
                  </IconButton>
                ) : (
                  <BlockIcon />
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Paper>
        <Snackbar open={alert} autoHideDuration={6000} onClose={clickAlert}>
          <Alert variant="filled" severity={alertType} onClick={clickAlert}>
            {message}
          </Alert>
        </Snackbar>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={12}>
              <div align="center">
                <h1>Pagamentos</h1>
              </div>
              <div align="right">
                <FormControl variant="outlined">
                  <InputLabel>Mês</InputLabel>
                  <Select value={mes} onChange={handleChangeMes} label="Mês">
                    {meses.map((m) => (
                      <MenuItem value={m.valor}>{m.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined">
                  <InputLabel>Ano</InputLabel>
                  <Select value={ano} onChange={handleChangeAno} label="Ano">
                    {anos.map((a) => (
                      <MenuItem value={a.valor}>{a.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid style={{ margin: '2%' }} item xs={12}>
              <ButtonGroup
                fullWidth
                color="primary"
                aria-label="outlined primary button group"
              >
                <Button
                  variant={tipo === 'ASSINATURAS' ? 'contained' : ''}
                  onClick={() => handleTipo('ASSINATURAS')}
                >
                  ASSINATURAS
                </Button>
                <Button
                  variant={tipo === 'SERVICOS' ? 'contained' : ''}
                  onClick={() => handleTipo('SERVICOS')}
                >
                  SERVIÇOS
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tipo === 'ASSINATURAS' ? rowsAssinaturas() : rowsServicos()}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>
      <Reembolso
        openModal={openReembolso}
        setOpenModal={setOpenReembolso}
        idPagamento={idPagamento}
        setAlert={setAlert}
        setAlertType={setAlertType}
        setMessage={setMessage}
      />
    </>
  );
}

export default Cupons;
